import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  Form,
} from "reactstrap";

//import images
import logoDark from "../assets/qaManagemet/AntsQualityLogo.png";
import logoSm from "../assets/qaManagemet/smlogo.png";

//import Components
import SearchOption from "../Components/Common/SearchOption";
import LightDark from "../Components/Common/LightDark";
import ProfileDropdown from "../Components/Common/ProfileDropdown";

import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import logolight from "../../src/assets/qaManagemet/AntsQualityLightLogo.png";
import { changeSidebarVisibility } from "../slices/thunks";
import { getLoggedInUser } from "../helpers/fakebackend_helper";
import HeaderDiscountDisplay from "../OrderingSystem/Dashboard/components/CardComponent/HeaderDiscountDisplay";

const Header = ({ onChangeLayoutMode, layoutModeType, headerClass }) => {
  const dispatch = useDispatch();
  const authUser = getLoggedInUser();

  const isSuperAdmin = authUser.user.roles.includes("SuperAdmin");
  const selectDashboardData = createSelector(
    (state) => state.Layout.sidebarVisibilitytype,
    (sidebarVisibilitytype) => sidebarVisibilitytype
  );
  const sidebarVisibilitytype = useSelector(selectDashboardData);

  const [search, setSearch] = useState(false);
  const toogleSearch = () => {
    setSearch(!search);
  };
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [daysRemaining, setDaysRemaining] = useState(null);

  useEffect(() => {
    try {
      const userData = JSON.parse(localStorage.getItem("user"));
      if (!userData?.expiryDate) return;

      const expiry = new Date(userData.expiryDate);
      const today = new Date();
      const diffDays = Math.ceil((expiry - today) / (1000 * 3600 * 24));
      setDaysRemaining(diffDays);

      if (diffDays < 0) setSubscriptionStatus("Expired");
      else if (diffDays <= 7) setSubscriptionStatus("Expiring Soon");
      else setSubscriptionStatus("");
    } catch (err) {
      console.error(err);
    }
  }, []);

  const toogleMenuBtn = () => {
    var windowSize = document.documentElement.clientWidth;
    dispatch(changeSidebarVisibility("show"));

    if (windowSize > 767)
      document.querySelector(".hamburger-icon").classList.toggle("open");

    if (document.documentElement.getAttribute("data-layout") === "horizontal") {
      document.body.classList.contains("menu")
        ? document.body.classList.remove("menu")
        : document.body.classList.add("menu");
    }

    if (
      sidebarVisibilitytype === "show" &&
      (document.documentElement.getAttribute("data-layout") === "vertical" ||
        document.documentElement.getAttribute("data-layout") === "semibox")
    ) {
      if (windowSize < 1025 && windowSize > 767) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "sm"
          ? document.documentElement.setAttribute("data-sidebar-size", "")
          : document.documentElement.setAttribute("data-sidebar-size", "sm");
      } else if (windowSize > 1025) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute("data-sidebar-size") === "lg"
          ? document.documentElement.setAttribute("data-sidebar-size", "sm")
          : document.documentElement.setAttribute("data-sidebar-size", "lg");
      } else if (windowSize <= 767) {
        document.body.classList.add("vertical-sidebar-enable");
        document.documentElement.setAttribute("data-sidebar-size", "lg");
      }
    }

    if (document.documentElement.getAttribute("data-layout") === "twocolumn") {
      document.body.classList.contains("twocolumn-panel")
        ? document.body.classList.remove("twocolumn-panel")
        : document.body.classList.add("twocolumn-panel");
    }
  };

  return (
    <React.Fragment>
      <header id="page-topbar" className={`${headerClass} color-white`}>
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex">
              <div className="navbar-brand-box horizontal-logo">
                <Link to="/" className="logo logo-dark">
                  <span className="logo-sm">
                    <img src={logoSm} alt="" height="22" />
                  </span>
                  <span className="logo-lg xyz">
                    <img src={logoDark} alt="" height="30" />
                  </span>
                </Link>

                <Link to="/" className="logo logo-light">
                  <span className="logo-sm">
                    <img src={logoSm} alt="" height="22" />
                  </span>
                  <span className="logo-lg abc">
                    <img src={logolight} alt="" height="30" />
                  </span>
                </Link>
              </div>

              <button
                onClick={toogleMenuBtn}
                type="button"
                className="btn btn-sm px-3 fs-16 header-item vertical-menu-btn topnav-hamburger"
                id="topnav-hamburger-icon"
              >
                <span className="hamburger-icon">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>
              <Link to="/dashboard">
                <img
                  src={"/" + window.APP_CONFIG.tenent + "/logo.png"}
                  alt=""
                  height="35"
                  className="d-md-none px-3 mt-3"
                />
              </Link>
            </div>

            <div className="d-flex align-items-center gap-2">
              {/* Subscription Capsule */}
              {subscriptionStatus && (
                <span
                  className={`badge ms-2 ${
                    subscriptionStatus === "Expired"
                      ? "bg-danger"
                      : subscriptionStatus === "Expiring Soon"
                      ? "bg-warning text-dark"
                      : "bg-success"
                  }`}
                  style={{
                    borderRadius: "50px",
                    padding: "5px 12px",
                    fontSize: "0.8rem",
                  }}
                >
                  {subscriptionStatus}
                  {subscriptionStatus === "Expiring Soon" && daysRemaining >= 0
                    ? ` (${daysRemaining} ${
                        daysRemaining === 1 ? "day" : "days"
                      })`
                    : ""}
                </span>
              )}

              {/* Discount Display - Shows only when discounts are available */}
              {!isSuperAdmin && <HeaderDiscountDisplay />}

              {/* POS Button */}
               {!isSuperAdmin && (
                <Link to="/kds" className="ms-2">
                  <button className="btn btn-dark btn-sm">
                    <i className="ri-tv-2-line"></i> KDS
                  </button>
                </Link>
              )}
              {!isSuperAdmin && (
                <Link to="/pos" className="ms-2">
                  <button className="btn btn-dark btn-sm">
                    <i className="ri-tv-2-line"></i> POS
                  </button>
                </Link>
              )}

              {/* NotificationDropdown */}
              {/* <NotificationDropdown /> */}

              {/* ProfileDropdown */}
              <ProfileDropdown />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
